// src/components/ClearValidationButton.tsx
import React from "react";
import { Button, Modal, Text, Group, Alert, Stack } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useProjectId } from "../hooks/useProjectId";
import { useDeleteMultiplacerRoomValidationMutation } from "../../openapi";

export const ClearValidationButton: React.FC = () => {
  const projectId = useProjectId();
  const [opened, { open, close }] = useDisclosure(false);
  const [clear, { isLoading, isSuccess, isError, data }] =
    useDeleteMultiplacerRoomValidationMutation();

  const handleClear = async () => {
    await clear({ projectNo: projectId });
    // close();
  };

  return (
    <>
      <Button
        variant="outline"
        color="red"
        size="sm"
        onClick={open}
        leftSection={<span style={{ fontSize: "1.1em" }}>🗑️</span>}
      >
        Fjern valideringer
      </Button>

      <Modal
        opened={opened}
        onClose={close}
        title={<Text fw={600}>Fjern valideringer?</Text>}
        centered
      >
        <Stack gap="md">
          <Text size="sm">
            Er du sikker på at du vil fjerne <strong>alle valideringer</strong> for dette
            prosjektet?
          </Text>

          {isError && (
            <Alert color="red" title="Feil">
              Kunne ikke fjerne valideringer. Prøv igjen.
            </Alert>
          )}

          {isSuccess && (
            <Alert color="green" title="Suksess">
              Fjernet valideringer for <strong>{data.deletedCount}</strong> rom.
            </Alert>
          )}

          {!isSuccess && (
            <Group justify="flex-end" gap="xs">
              <Button variant="subtle" color="gray" onClick={close}>
                Avbryt
              </Button>
              <Button color="red" onClick={handleClear} loading={isLoading} disabled={isLoading}>
                Fjern
              </Button>
            </Group>
          )}
        </Stack>
      </Modal>
    </>
  );
};
